export default __webpack_public_path__ + "static/media/flag-brazil-inactive.39e908b8.svg";